(function () {
  function findProductForm(event) {
    return event && event.currentTarget
      ? event.currentTarget.closest('product-form')
      : null;
  }

  function submitToCheckout(event) {
    var productForm = findProductForm(event);
    var cardButton = productForm
      ? productForm.querySelector('[data-playblim-card-button="true"]')
      : null;

    if (cardButton && cardButton !== event.currentTarget && !cardButton.disabled) {
      cardButton.click();
      return;
    }

    var customForm = event && event.currentTarget
      ? event.currentTarget.closest('form[action*="/cart/add"]')
      : null;

    if (customForm) {
      submitCustomForm(customForm);
      return;
    }

    window.location.assign('/checkout');
  }

  function submitCustomForm(form) {
    var submitButtons = form.querySelectorAll('button');
    submitButtons.forEach(function (button) {
      button.disabled = true;
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: new FormData(form),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to add the selected product to cart.');
        }
        window.location.assign('/checkout');
      })
      .catch(function (error) {
        console.error(error);
        submitButtons.forEach(function (button) {
          button.disabled = false;
        });
      });
  }

  window.playblimCustomCheckout = function (event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    submitToCheckout(event);
  };

  window.playblimPayPalCheckout = function (event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (typeof window.itcProdPagePayPal === 'function') {
      try {
        window.itcProdPagePayPal(event);
        return;
      } catch (error) {
        console.error('PayPal checkout handler failed; using Shopify checkout.', error);
      }
    }

    submitToCheckout(event);
  };

  function normalizeCardLabels() {
    var cardLabel = 'PAY WITH DEBIT/CREDIT CARD';

    document.querySelectorAll('[data-playblim-card-button="true"]').forEach(function (button) {
      var label = button.querySelector('.button__label');

      if (!label) {
        label = document.createElement('span');
        label.className = 'button__label';
        button.insertBefore(label, button.firstChild);
      }

      if (label.textContent.trim() !== cardLabel) {
        label.textContent = cardLabel;
      }

      label.style.removeProperty('display');
      label.style.removeProperty('visibility');
      label.style.removeProperty('opacity');
      button.setAttribute('aria-label', cardLabel);
      button.setAttribute('data-button-label', cardLabel);
    });

    document.querySelectorAll('#opc-override-dyn-c-btn').forEach(function (button) {
      if (button.textContent.trim() !== cardLabel) {
        button.textContent = cardLabel;
      }
      button.setAttribute('aria-label', cardLabel);
    });
  }

  document.addEventListener('DOMContentLoaded', normalizeCardLabels);
  new MutationObserver(normalizeCardLabels).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
